var eId;
login_state.e_id ? eId = login_state.e_id : eId = sessionStorage.getItem('murmur');
var PrivateLikes = 0;
var PrivateCollection = 0;
var _creaTion = false;
let genDerId = 2;
var testStr = /[^\p{L}\d_\s#]/gu;

//tags 添加方法
// if (window.location.pathname.indexOf(`${lang_path}/character/edit/`) == -1) {
//     let tAgs = document.querySelectorAll('.tagsId div');
//     tAgs.forEach((tag, i) => {
//         tag.addEventListener('click', (e) => {
//             // 检查当前元素是否有 'active' 类
//             if (e.target.classList.contains('active')) {
//                 // 如果有 'active' 类，则从 seLectedTags 数组中移除
//                 seLectedTags = seLectedTags.filter(id => id !== Number(e.target.id));
//                 e.target.classList.remove('active');
//             } else {
//                 // 如果没有 'active' 类，则添加到 seLectedTags 数组中

//                 if (seLectedTags.length >= 3) return;
//                 seLectedTags.push(Number(e.target.id));

//                 e.target.classList.add('active');
//             }
//             //  var $label = $('label[for="tags"]');
//             //  $label.text(`Tags(${seLectedTags.length}/3)`);
//             $('.profile_mask .tags_num').html(seLectedTags.length);
//         });
//     });
// };
var nickNameEle = document.getElementById('nick_name');
var personaLizedEle = document.getElementById('edit_personality');
nickNameEle.addEventListener('input', function () {
    clearErrors('nicknameError');
    var name = this.value.trim();
    if (name === '') {
        showError('nicknameError', i18n[lang].public_enter_character);
    } else if (name.length <= 2) {
        showError('nicknameError', i18n[lang].public_length_characters_2);
    } else if (name.length >= 40) {
        showError('nicknameError', i18n[lang].public_length_characters_40);
    }
    // else if (test_name(name)){
    //     showError('nicknameError', 'The Username may not contain special symbols.');
    // }
});
personaLizedEle.addEventListener('input', function () {
    clearErrors('personalityError');
    var personaLized = this.value.trim();
    if (personaLized.length > 500) {
        showError('personalityError', i18n[lang].public_length_characters_500);
    }
    // else if (test_name(personaLized)){
    //     showError('personalityError', 'The Introduction may not contain special symbols.');
    // }
});
var test_list = [
    /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_]+\/$/i,
    /^(https?:\/\/)?(www\.)?tiktok\.com\/@[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(www\.)?youtube\.com\/@[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(www\.)?facebook\.com\/@[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(www\.)?patreon\.com\/[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(www\.)?ko-fi\.com\/[a-zA-Z0-9_]+$/i,
    /^(https?:\/\/)?(www\.)?onlyfans\.com\/[a-zA-Z0-9_]+$/i,
];
$('.social_input_zoon').on('input', function(){
    if($(this).val().length>0){
        $(this).addClass('active');
        if(!test_list[$(this).index('.social_input_zoon')].test($(this).val())){
            $('.social_error').eq($(this).index('.social_input_zoon')).addClass('active');
            $(this).removeClass('allowed');
        }else{
            $('.social_error').eq($(this).index('.social_input_zoon')).removeClass('active');
            $(this).addClass('allowed');
        }
    }else{
        $(this).removeClass('active').removeClass('allowed');
        $('.social_error').eq($(this).index('.social_input_zoon')).removeClass('active');
    };
});
$('.input_empty').on('click',function(e){
    $(this).prev().removeClass('active').val('');
    $('.social_error').eq($(this).index('.input_empty')).removeClass('active');
});
$('.social_zoon label').on('click',function(e){
    if($(this).find('input[type="checkbox"]').prop('checked')){
        $(this).find('.social_input_zoon').focus();
    }else{
        $(this).find('.social_input_zoon').removeClass('active').val('');
        $('.social_error').eq($(this).index('.social_zoon label')).removeClass('active');
    }
});
function update_userinfo() {
    getAjax(_url.getUserInfo, { e_id: eId }).then(response => {
        if (response.code == 200) {
            // 顶部导航条信息更新
            if (response.data.avatar_url) {
                if ($('.loginButton .avatarUser').length > 0) {
                    $('.loginButton .avatarUser').remove();
                    $('.loginButton').append(`<img src="${response.data.avatar_url}" style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain;"/>`);
                } else {
                    $('.loginButton img').attr({ 'src': response.data.avatar_url })
                }
                if ($('.userInfo .info > .avatar').length > 0) {
                    $('.userInfo .info >.avatar').remove();
                    $('.userInfo .info>div').before(`<img src="${response.data.avatar_url}" style="width: 2rem; height: 2rem; border-radius: 50%; object-fit: contain;margin-right: .875rem;">`);
                } else {
                    $('.userInfo .info > img').attr({ 'src': response.data.avatar_url });
                }
            };
            try {
                response.data.avatar_url ? $('.h1_section .left_h1').attr({ 'src': response.data.avatar_url }) : null;
                $('#plan_bg').removeClass('active');
                response.data.nickname ? $('#user_name').html(response.data.nickname) : null;
            } catch (e) { };
            response.data.nickname ? $('#nick_name').val(response.data.nickname) : null;
            //人物头像
            response.data.avatar_url ? $('.user_img').attr({ 'src': response.data.avatar_url }) : null;
            //人物名称
            response.data.nickname ? $('.profile_user_name').html(response.data.nickname) : null;
            response.data.avatar_url ? $('.profile_user_img').attr({ 'src': response.data.avatar_url }) : null;
            response.data.introduction ? $('#profile_introduction').html(response.data.introduction) : $('#profile_introduction').html(i18n[lang].public_no_Introduction);
            setTimeout(function () {
                try {
                    if (window.innerWidth <= 650 && iD('profile_introduction').getBoundingClientRect().height > 48) {
                        iD('profile_introduction').classList.add('show')
                        iD('more_introduction').classList.add('show')
                    } else {
                        iD('more_introduction').classList.remove('show')
                        iD('profile_introduction').classList.remove('show')
                    }
                } catch (e) { }
            }, 10);
            //用户性别
            if (response.data.gender) {
                if (response.data.gender == 0) {
                    $('label[for="_male"]').trigger('click')
                } else if (response.data.gender == 1) {
                    $('label[for="_female"]').trigger('click')
                } else if (response.data.gender == 2) {
                    $('label[for="non_binary"]').trigger('click')
                }
            };
            console.log(response.data.private_collection,response.data.private_likes);
            if (response.data.private_collection == 1) {
                $('input#favorites').prop('checked',false)
            } else if (response.data.private_collection == 0) {
                $('input#favorites').prop('checked',true)
            };
            if (response.data.private_likes == 1) {
                $('input#likes').prop('checked',false)
            } else if (response.data.private_likes == 0) {
                $('input#likes').prop('checked',true)
            };
            seLectedTags = [];
            // var _category = 0;
            // if (response.data.categoryJson) {
            //     for (var udd = 0; udd < response.data.categoryJson.length; udd++) {
            //         for (var uii = 0; uii < $('.tagsId div').length; uii++) {
            //             if (Number($('.tagsId div').eq(uii).attr('id')) == response.data.categoryJson[udd].id) {
            //                 $('.tagsId div').eq(uii).addClass('active');
            //                 _category++;
            //                 seLectedTags.push(response.data.categoryJson[udd].id);
            //                 break;
            //             }
            //         }
            //     };
            // };
            if (response.data.social_links) {
                for ( var udd in response.data.social_links) {
                    try{iD('a_'+udd).classList.remove('active');
                    response.data.social_links[udd]?iD('a_'+udd).classList.add('active'):null;
                    response.data.social_links[udd]?iD('a_'+udd).setAttribute('href', response.data.social_links[udd]):null;}catch(e){}
                    response.data.social_links[udd]?iD(udd).checked = true:iD(udd).checked = false;
                    response.data.social_links[udd]?iD('input_'+udd).value=response.data.social_links[udd]:null;
                    response.data.social_links[udd]?iD('input_'+udd).classList.add('allowed'):null;
                    response.data.social_links[udd]?iD('input_'+udd).classList.add('active'):null;
                }
            }
            // $('.profile_mask .tags_num').html(_category);
            response.data.introduction ? $('#edit_personality').val(response.data.introduction) : null;
            //plan 类型
            // scrollToTop(seLectorAll('.profile_mask .ivu-col-span-xxl-10'));
            var userInfoData = response.data;
            userInfoData.eid = eId;
            response.data ? cookie.setcookie('userInfoData', JSON.stringify(userInfoData), 90) : null;
            $('.profile_mask .ivu-col-span-xxl-10').scrollTop(0);
            if (response.data.avatar_url) {
                if ($('.profile_mask .avatarBox .avatarList').length > 0) {
                    $('.profile_mask .avatarBox .avatarList').html(`<img src="${response.data.avatar_url}" data-src="${response.data.avatar_url}"/>`)
                } else {
                    $('.profile_mask .avatarBox').append(`<div class="avatarList"><img src="${response.data.avatar_url}" data-src="${response.data.avatar_url}"/></div>`);
                }
            };
            if (userInfoData.email) {
                document.querySelectorAll('.change_info .email').forEach(function (box) {
                    box.value = userInfoData.email
                });
            };
        } else if (response.error == 20901) {
            error(i18n[lang].error_20901);
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        } else if (response.error == 20902) {
            error(i18n[lang].error_20902);
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        } else if (response.code == 204) {
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        }
    });
};
var _flag_Submitted=true;
document.getElementById('edit_form').addEventListener('submit', function (event) {
    // 阻止表单默认提交行为
    event.preventDefault();
    if (!_flag_Submitted) {
        error(i18n[lang].public_Image_uploading)
        return false;
    }
    const avaTarEle = document.querySelector('.profile_mask .avatarList img');
    const switchBoxFalseEle = document.querySelector('.profile_mask .switchBoxfalse');
    // 获取表单输入值
    const name = nickNameEle.value.trim();
    var avatar_url = avaTarEle ? avaTarEle.getAttribute('data-src') : null;
    var _select_top = $('.formItem').eq(3).offset().top;
    // const nsfw = switchBoxFalseEle.style.display !== 'none' ? 0 : 1;
    // const tagsId = seLectedTags.length ? seLectedTags.join(',') : '';
    const personaLized = personaLizedEle.value.trim();
    if ($('.visibilityRadio input.favorites').prop('checked')) {
        PrivateCollection = 0;
    } else {
        PrivateCollection = 1
    };
    if ($('.visibilityRadio input.likes').prop('checked')) {
        PrivateLikes = 0;
    } else {
        PrivateLikes = 1
    };
    let isValid = true;
    var data = {
        nickname: null,
        e_id: eId,
        gender: genDerId,
        // nsfw: nsfw,
        // categoryid: tagsId,
        introduction: personaLized,
        private_collection: PrivateCollection,
        private_likes: PrivateLikes,
        social_links:{}
    }

    if (personaLized.length > 500) {
        showError('personalityError', 'Introduction content is limited to a maximum of 500 characters.');
        $('.profile_mask .create .scrolleBar').scrollTop($('.formItem').eq(5).offset().top - 100);
        isValid = false;
    }
    // else if (test_name(personaLized)){
    //     showError('personalityError', 'The Introduction may not contain special symbols.');
    //     $('.profile_mask .create .scrolleBar').scrollTop($('.formItem').eq(5).offset().top-100);
    //     isValid = false;
    // }
    // 验证头像
    if (!avatar_url) {
        // $('.uploadzoon').addClass('nobind');
    } else {
        data.avatar_url = avatar_url;
    }
    // 验证昵称
    // var _test = /^[0-9a-zA-Z_]{1,}$/;
    if (name === '') {
        showError('nicknameError', i18n[lang].public_enter_character);
        $('.profile_mask .create .scrolleBar').scrollTop(0);
        isValid = false;
    } else if (name.length <= 2) {
        showError('nicknameError', i18n[lang].public_length_characters_2);
        $('.profile_mask .create .scrolleBar').scrollTop(0);
        isValid = false;
    } else if (name.length >= 40) {
        showError('nicknameError', i18n[lang].public_length_characters_40);
        $('.profile_mask .create .scrolleBar').scrollTop(0);
        isValid = false;
    }
    // else if (test_name(name)){
    //     showError('nicknameError', 'The Username may not contain special symbols.');
    //     $('.profile_mask .create .scrolleBar').scrollTop(0);
    //     isValid = false;
    // }
    else {
        data.nickname = name;
    }
    for(var i = 0 ; i < $('.social_input_zoon').length; i++){
        if($('.social_input_zoon').eq(i).attr('class').indexOf('allowed')>-1){
            data.social_links[$('.social_input_zoon').eq(i).attr('attr-id')] = adjustUrl($('.social_input_zoon').eq(i).val(),$('.social_input_zoon').eq(i).attr('attr-id'));
        }else{
            data.social_links[$('.social_input_zoon').eq(i).attr('attr-id')] = '';
        }
    };
    if($('.social_error.active').length>0){
        isValid = false;
        $('.profile_mask .create .scrolleBar').scrollTop(400);
    }
    // 如果表单有效，则可以提交表单
    if (isValid && !_creaTion) {
        _creaTion = true;
        var starTime = new Date().getTime();
        $('#edit_form button').html('<img src="/images/account/loading.svg" alt="Loading">');
        getAjax(_url.setUserInfo, data).then(res => {
            $('#edit_form button').html('Save Changes');
            const responseDate = new Date().getTime();
            if (responseDate - starTime >= 5000) {
                _creaTion = false;
            } else {
                setTimeout(function () {
                    _creaTion = false;
                }, 5000 - (responseDate - starTime));
            }
            if (res.code == 200) {
                $('input.favorites').prop('checked', true);
                $('input.likes').prop('checked', true);
                success('The information has been saved.');
                $(this).parent().removeClass('active');
                $('.profile_mask').removeClass('active');
                $('.profile_mask .edit_profile').removeClass('active');
                $('body').removeClass('hide_pro');
                try { $('.ivu-layout-content').removeClass('hide_pro'); } catch (e) { };
                //更新用户信息
                update_userinfo();
                var userInfoData = JSON.parse(cookie.getcookie('userInfoData'));
                userInfoData.avatar_url = avatar_url;
                cookie.setcookie('userInfoData', JSON.stringify(userInfoData));
            } else if (res.code == 1306) {
                error(i18n[lang].public_length_characters_3);
            } else if (res.code == 2008) {
                error(i18n[lang].public_select_gender);
            } else if (res.code == 2013) {
                error(i18n[lang].public_length_Introduction_500);
            } else if (res.code == 500) {
                error(i18n[lang].public_Sever_Error);
            } else if (res.code == 1112) {
                showError('nicknameError', i18n[lang].public_username_is_taken);
                $('.profile_mask .create .scrolleBar').scrollTop(0);
                isValid = false;
            } else if (res.code == 9001) {
                error(i18n[lang].public_Sever_failed);
            } else {
                error(i18n[lang].public_Network_error);
            }
        })
        // this.submit(); // 取消注释以允许默认提交
    } else if (_creaTion) {
        error(i18n[lang].public_too_fast);
    }
});
function adjustUrl(url,source){
    if (source == 'FaceBook'){
        return url.replace(/.*\.com/,'https://www.facebook.com')
    } else if (source == 'Instagram'){
        return url.replace(/.*\.com/,'https://www.instagram.com')
    } else if (source == 'TikTok'){
        return url.replace(/.*\.com/,'https://www.tiktok.com')
    } else if (source == 'YouTube'){
        return url.replace(/.*\.com/,'https://www.youtube.com')
    } else if (source == 'Twitter'){
        return url.replace(/.*x\.com/,'https://x.com').replace(/.*twitter\.com/,'https://twitter.com')
    } else if (source == 'Patreon'){
        return url.replace(/.*\.com/,'https://www.patreon.com')
    } else if (source == 'Ko-fi'){
        return url.replace(/.*\.com/,'https://ko-fi.com')
    } else if (source == 'OnlyFans'){
        return url.replace(/.*\.com/,'https://onlyfans.com')
    }
}
function showError(elementId, message) {
    document.getElementById(elementId).textContent = message;
};
function clearErrors(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.textContent = '';
    } else {
        //   console.error(`元素 ID "${elementId}" 不存在于文档中`);
    }
}
//edit_personality


// 初始化
function profile_init() {
    $('#profile_image').cropper({
        viewMode: 1,
        dragMode: 'move',
        initialAspectRatio: 1,
        preview: '.previewBox',
        // 是否在容器上显示网格背景
        background: true,
        // 定义自动剪裁区域的大小
        // autoCropArea: 1,
        // 是否允许鼠标 缩放图片
        zoomOnWheel: true,
        // 是否允许改变剪裁框的大小
        cropBoxResizable: false,
        // 是否可以移动裁剪框
        cropBoxMovable: false,
        // 是否允许旋转图片
        rotatable: true,
        //是否显示裁剪框虚线
        guides: false,
        // 是否允许缩放图像
        scalable: true,
        // 是否允许放大图像
        zoomable: true,
        // 设置最大最小倍数
        zoom_in:.5,
        zoom_out: 2,
        // 图片在����时是否跟随��标
        // 是否允许图片移动
        movable: true,
        //裁切框的宽高比
        aspectRatio: [4, 5],
        // 裁剪框显示的大小 默认0.8
        autoCropArea: 0.9,
        // 初始化时，自动裁剪图片
        // autoCrop:true,
    })
}

var IsChangeAvatar = 0;
var oriGinalFile = null;
var oriGinalFileSize = null;
var oriGinalimg = null;
var oriGinalType = null;
var oriGinalUrl = null;
cookie.getcookie('userInfoData')?oriGinalimg= JSON.parse(cookie.getcookie('userInfoData')).avatar_url:oriGinalimg='/images/index/icon-login.svg'
$('#uploadzoon,#profile_change_zoon').on('click', function (e) {
    e.stopPropagation();
    if (!IsChangeAvatar) {
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        // 根据屏幕宽度设置canvas的大小
        var CanvasWidth = screenWidth > 750 ? 408 : 306;
        var CanvasHeight = CanvasWidth;
        $(window).resize(function () {
            screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            // 根据屏幕宽度设置canvas的大小
            CanvasWidth = screenWidth > 750 ? 408 : 306;
            CanvasHeight = CanvasWidth;
        });
        if(!$('.edit_avatar').length){
            $('body').append(`
            <div class="change_avatar edit_avatar" style="display: none;">
                <div class="change_avatar_box">
                <p><span>${i18n[lang].edit_photo}</span> <i class="close"></i></p>
                <div class="file_box"><span>${i18n[lang].select_photo}</span><input type="file" id="upLoad" accept=".jpg, .jpeg, .png, .bmp, .webp"></div>
                <div class="img_box">
                    <div class="canvas_box">
                            <img src="" id="profile_image" alt="" class="image"> 
                    </div>
                    <div class="operation">
                    <span><span>${i18n[lang].change_photo}</span><label for="upLoad"></label></span>
                    <img class="enlarge" src="/images/account/add.svg" alt="Enlarge" title="${i18n[lang].zoom_in}">
                    <img class="narrow" src="/images/account/minimize.svg" alt="narrow" title="${i18n[lang].zoom_out}">
                    <img class="left_rotate" src="/images/account/backup.svg" alt="Backup" title="${i18n[lang].rotate}">
                    <!-- <img class="mirror" src="/images/account/mirror.svg" alt="Backup" title="${i18n[lang].horizontal_flip}">
                    <img class="b_mirror" src="/images/account/v-mirror.svg" alt="Mirror" title="${i18n[lang].vertical_flip}"> --!>
                    </div>
                </div>
                <div class="btn">
                    <span class="cancel">${i18n[lang].cancel}</span>
                    <span class="submit nobind" id="edit_submit"><span>${i18n[lang].feedback_submit}</span><img src="/images/account/loading.svg" alt="Loading"></span>
                </div>
                </div>
            </div>
            `);
        };
        $('label[for="upLoad"]').trigger('click');
        $('.img_box .canvas_box').css('width', CanvasWidth)
        $('.img_box .canvas_box').css('height', CanvasHeight)
        // 初始化
        // if(){
        //     profile_init();
        // }else{
            profile_init();
        // };
        $('#upLoad').on('change', async function () {
            $('.edit_avatar').show();
            IsChangeAvatar = 1;
            // $('.edit_avatar .change_avatar_box .file_box').hide();
            $('.edit_avatar .change_avatar_box .img_box').show();
            $('.edit_avatar .change_avatar_box .btn span.submit').removeClass('nobind');
            _flag_Submitted=true;
            oriGinalFile = this.files[0];
            console.log(oriGinalFile);
            oriGinalFileSize = oriGinalFile.size;
            oriGinalType = oriGinalFile.name.split('.').pop().toLowerCase();
            var reader = new FileReader();
            reader.abort();
            reader.onload = function (evt) {
                var replaceSrc = evt.target.result;
                var img = new Image();
                img.src = replaceSrc;
                oriGinalUrl = replaceSrc;
                img.onload = function () {
                };
                // if(oriGinalType == 'gif'){
                //     //更换cropper的图片
                //     async function autoUpload (){
                //         if (!isnetwork()||oriGinalFileSize==0) { return false; };
                //         if(oriGinalFileSize&&oriGinalFileSize>5242880){
                //             $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                //             _flag_Submitted=false;
                //             $('.edit_avatar').remove();
                //             IsChangeAvatar = 0;
                //             $('#upLoad').val('');
                //             $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                //             error(i18n[lang].public_image_exceed_5);
                //             oriGinalFileSize=0;
                //             return false;
                //         } else {
                //             oriGinalFileSize=0;
                //             IsChangeAvatar = 0;
                //             $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                //             _flag_Submitted=false;
                //             $('.profile_mask .edit_profile #edit_form .change_zoon').removeClass('active');
                //             //获取截取后canvas实例
                //             const dataURL = oriGinalUrl;
                //             const blob = await fetch(dataURL).then(res => res.blob());
                //             console.log(543,blob);
                //             const file = blobToFile(blob, oriGinalFile.name);
                //             const formData = new FormData();
    
                //             formData.append('file', file);
                //             var img = new Image();
                //             img.src = dataURL;
                //             img.onload = function () {
                //             };
                //             if ($('.profile_mask .avatarBox .avatarList').length > 0) {
                //                 $('.profile_mask .avatarBox .avatarList').html(`<img src="${dataURL}" data-src="${dataURL}"/>`)
                //                 $('.profile_mask .avatarBox .avatarList').addClass('avatar_mask');
                //             } else {
                //                 $('.profile_mask .avatarBox').append(`<div class="avatarList"><img src="${dataURL}" data-src="${dataURL}"/></div>`);
                //                 $('.profile_mask .avatarBox .avatarList').addClass('avatar_mask');
                //             };
                //             $('.profile_mask .avatarBox .avatarList').show();
                //             $('.edit_avatar').remove();
                //             fetch(doman + _url.fileUpload, {
                //                 method: 'POST',
                //                 body: formData,
                //                 headers: {
                //                     "Access-Token": login_state.AccessToken,
                //                     "Basic-Params": JSON.stringify(getHeaderParams()),
                //                 }
                //             })
                //             .then(response => {
                //                 // 检查响应状态码是否在 200-299 范围内
                //                 if (response.ok) {
                //                     return response.json(); // 解析JSON格式的响应数据
                //                 } else {
                //                     throw new Error('Network response was not ok');
                //                 }
                //             })
                //             .then(res => {
                //                 $('.profile_mask .avatarBox .avatarList').removeClass('avatar_mask');
                //                 $('.profile_mask .edit_profile #edit_form .change_zoon').addClass('active');
                //                 $('.edit_avatar .change_avatar_box .btn span.submit').removeClass('nobind');
                //                 _flag_Submitted=true;
                //                 switch (res.code) {
                //                     case 200:
                //                         var img = new Image();
                //                         img.src = res.data;
                //                         img.onload = function () {
                //                         };
                //                         $('.profile_mask .avatarBox .avatarList').show();
                //                         if($('.profile_mask .avatarBox .avatarList img').length > 0){
                //                             $('.profile_mask .avatarBox .avatarList img').attr({'data-src':res.data})
                //                         }else if ($('.profile_mask .avatarBox .avatarList').length > 0) {
                //                             $('.profile_mask .avatarBox .avatarList').html(`<img src="${res.data}" data-src="${res.data}"/>`)
                //                         } else {
                //                             $('.profile_mask .avatarBox').append(`<div class="avatarList"><img src="${res.data}" data-src="${res.data}"/></div>`);
                //                         };
                //                         $('#uploadzoon').removeClass('nobind');
                //                         $('#uploadzoon').remove();
                                        
                //                         success('Avatar Uploaded');
                //                         // $('.edit_avatar .change_avatar_box .file_box').show();
                //                         // $('.edit_avatar .change_avatar_box .img_box').hide();
                //                         break;
                //                     case 9001:
                //                         error(i18n[lang].public_Network_error);
                //                         break;
                //                     case "1306" || 1306:
                //                         error(i18n[lang].public_image_exceed_5)
                //                         break;
                //                     default:
                //                         error(i18n[lang].public_Something_wrong);
                //                         break;
                //                 }
                //                 if(res.code!=200){
                //                     $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                //                 }
                //             })
                //             .catch(error => {
                //                 $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                //                 _flag_Submitted=false;
                //                 $('.edit_avatar').remove();
                //                 IsChangeAvatar = 0;
                //                 $('#upLoad').val('');
                //                 $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                //                 error(i18n[lang].public_Network_error);
                //                 oriGinalFileSize=0;
                //             });
                //         };
                //         oriGinalFileSize=0;
                //     };
                //     autoUpload ();
                // }else{
                    //更换cropper的图片
                    $('#profile_image').cropper('replace', replaceSrc, false);//默认false，适应高度，不失真
                // }
            }
            reader.onerror = function(error) {
                // 处理加载错误的事件
                console.error('File reading error', error);
            };
            reader.readAsDataURL(oriGinalFile);
            $('#upLoad').val('');
            IsChangeAvatar = 0;
            reader = null;
        });
        $('body').on('click', '.edit_avatar .change_avatar_box .btn span.cancel', function () {
            // $('.edit_avatar .change_avatar_box .file_box').show();
            // $('.edit_avatar .change_avatar_box .img_box').hide();
            $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
            _flag_Submitted=false;
            $('.edit_avatar').remove();
            IsChangeAvatar = 0;
            oriGinalFileSize = 0;
            $('#upLoad').val('');
        });
        $('body').on('click', '.edit_avatar .change_avatar_box .close', function () {
            // $('.edit_avatar .change_avatar_box .file_box').show();
            // $('.edit_avatar .change_avatar_box .img_box').hide();
            $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
            _flag_Submitted=false;
            $('.edit_avatar').remove();
            IsChangeAvatar = 0;
            oriGinalFileSize = 0;
            $('#upLoad').val('');
        });
        $('body').on('click', '.edit_avatar .change_avatar_box .btn span.submit', async function (e) {
            // e.stopPropagation();
            if (!isnetwork()||oriGinalFileSize==0) { return false; };
            if ($(this).attr('class').indexOf('nobind') >= 0) {
                return false;
            } else if(oriGinalFileSize&&oriGinalFileSize>5242880){
                $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                _flag_Submitted=false;
                $('.edit_avatar').remove();
                IsChangeAvatar = 0;
                $('#upLoad').val('');
                $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                error(i18n[lang].public_image_exceed_5);
                oriGinalFileSize=0;
                return false;
            } else {
                oriGinalFileSize=0;
                IsChangeAvatar = 0;
                $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                _flag_Submitted=false;
                $('.profile_mask .edit_profile #edit_form .change_zoon').removeClass('active');
                let that = $(this);
                that.find('img').css('opacity', 1);
                //获取截取后canvas实例
                var canVas = $('#profile_image').cropper('getCroppedCanvas');
                // const dataURL = canVas.toDataURL('image/'+oriGinalType,0.6);
                const dataURL = canVas.toDataURL('image/png',0.6);
                const blob = await fetch(dataURL).then(res => res.blob());
                const file = blobToFile(blob, oriGinalFile.name);
                const formData = new FormData();

                formData.append('file', file);
                var img = new Image();
                img.src = dataURL;
                img.onload = function () {
                };
                if ($('.profile_mask .avatarBox .avatarList').length > 0) {
                    $('.profile_mask .avatarBox .avatarList').html(`<img src="${dataURL}" data-src="${dataURL}"/>`)
                    $('.profile_mask .avatarBox .avatarList').addClass('avatar_mask');
                } else {
                    $('.profile_mask .avatarBox').append(`<div class="avatarList"><img src="${dataURL}" data-src="${dataURL}"/></div>`);
                    $('.profile_mask .avatarBox .avatarList').addClass('avatar_mask');
                };
                $('.profile_mask .avatarBox .avatarList').show();
                $('.edit_avatar').remove();
                fetch(doman + _url.fileUpload, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        "Access-Token": login_state.AccessToken,
                        "Basic-Params": JSON.stringify(getHeaderParams()),
                    }
                })
                .then(response => {
                    // 检查响应状态码是否在 200-299 范围内
                    if (response.ok) {
                        return response.json(); // 解析JSON格式的响应数据
                    } else {
                        throw new Error('Network response was not ok');
                    }
                })
                .then(res => {
                    that.find('img').css('opacity', 0);
                    $('.profile_mask .avatarBox .avatarList').removeClass('avatar_mask');
                    $('.profile_mask .edit_profile #edit_form .change_zoon').addClass('active');
                    $('.edit_avatar .change_avatar_box .btn span.submit').removeClass('nobind');
                    _flag_Submitted=true;
                    switch (res.code) {
                        case 200:
                            var img = new Image();
                            img.src = res.data;
                            img.onload = function () {
                            };
                            $('.profile_mask .avatarBox .avatarList').show();
                            if($('.profile_mask .avatarBox .avatarList img').length > 0){
                                $('.profile_mask .avatarBox .avatarList img').attr({'data-src':res.data})
                            }else if ($('.profile_mask .avatarBox .avatarList').length > 0) {
                                $('.profile_mask .avatarBox .avatarList').html(`<img src="${res.data}" data-src="${res.data}"/>`)
                            } else {
                                $('.profile_mask .avatarBox').append(`<div class="avatarList"><img src="${res.data}" data-src="${res.data}"/></div>`);
                            };
                            $('#uploadzoon').removeClass('nobind');
                            $('#uploadzoon').remove();
                            
                            success('Avatar Uploaded');
                            // $('.edit_avatar .change_avatar_box .file_box').show();
                            // $('.edit_avatar .change_avatar_box .img_box').hide();
                            break;
                        case 9001:
                            error(i18n[lang].public_Network_error);
                            break;
                        case "1306" || 1306:
                            error(i18n[lang].public_image_exceed_5)
                            break;
                        default:
                            error(i18n[lang].public_Something_wrong);
                            break;
                    }
                    if(res.code!=200){
                        $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                    }
                })
                .catch(error => {
                    $('.edit_avatar .change_avatar_box .btn span.submit').addClass('nobind');
                    _flag_Submitted=false;
                    $('.edit_avatar').remove();
                    IsChangeAvatar = 0;
                    $('#upLoad').val('');
                    $('.profile_mask .avatarBox .avatarList img').attr('src',oriGinalimg);
                    error(i18n[lang].public_Network_error);
                    oriGinalFileSize=0;
                });
            };
            oriGinalFileSize=0;
        });
        //放大缩小
        $('body').on('click', '.edit_avatar .narrow', function () {
            $('#profile_image').cropper('zoom', -0.1);
        });
        $('body').on('click', '.edit_avatar .enlarge', function () {
            $('#profile_image').cropper('zoom', 0.1);
        });
        //旋转
        $('body').on('click', '.left_rotate', function () {
            $('#profile_image').cropper('rotate', 90);
        });
    };
});
$('.profile_close').on('click', function () {
    $(this).parent().removeClass('active');
    $('.profile_mask').removeClass('active');
    $('body').removeClass('hide_pro');
    $('.ivu-layout-content').removeClass('hide_pro');
    $('.getcode').html('Get').removeClass('nobind');
    $('.input_box p').html('');
    $('.clause_delete .check').removeClass('active');
    $('.clause_delete .check').siblings('.delete_zoon').find('.delete_btn').addClass('fit');
    $('delete_now').removeClass('active').html('Delete Now');
    $('input.favorites').prop('checked', true);
    $('input.likes').prop('checked', true);
    // $('.tagsId div').removeClass('active');
    try{$('.public_mask').trigger('click')}catch(e){};
    for(var i = 0; i <$('.social_error').length; i++){
        if($('.social_error').eq(i).hasClass('active')){
            $('.social_error').eq(i).removeClass('active');
            $('.social_items').eq(i).find('input[type=checkbox]').prop('checked', false);
            $('.social_items').eq(i).find('input[type=text]').val('');
        }
    }
    if($(this).parent().hasClass('edit_profile ')){
        update_userinfo();
    }
});
//编辑人物信息
$('.profile_edit').on('click', function (e) {
    $('.edit_profile').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
    $('.ivu-layout-content').addClass('hide_pro');
    manage('Profile_Edit_Click', '');
    defaultDisplayOfScrollbar();
    update_userinfo();
});
function adjustTextareaHeight(textarea) {
    $(textarea).css('height', 'auto'); // 
    $(textarea).css('height', textarea.scrollHeight + 'px');
};